import Appreciation from "../assets/images/appreciation_notify.png";
import Leave from "../assets/images/leave_notify.png";
import Holiday from "../assets/images/holiday_notify.png";
import WorkAnniversary from "../assets/images/anniversary_notify.png";
import Birthday from "../assets/images/birthday_notify.png";
import EmployeeOfMonth from "../assets/images/eom_notify.png";
import { useGetNotificationQuery } from "../features/Notifications/notificationApi";
import { useNavigate } from "react-router-dom";
import Icon from "./Icon";
import { SkeletonNotification } from "./Skeleton";

const iconMap = {
  Appreciation: Appreciation,
  Leave: Leave,
  Holiday: Holiday,
  "Work Anniversary": WorkAnniversary,
  Birthday: Birthday,
  "Employee of The month": EmployeeOfMonth,
  "Your leave status changed": Leave,
};

const readableType = (t) => {
  if (t.includes("AppreciationNotification")) return "Appreciation";
  if (t.includes("LeaveNotification")) return "Leave";
  if (t.includes("HolidayNotification")) return "Holiday";
  if (t.includes("WorkAnniversaryNotification")) return "Work Anniversary";
  if (t.includes("BirthdayNotification")) return "Birthday";
  if (t.includes("EmployeeOfTheMonthNotification"))
    return "Employee of The month";
  if (t.includes("LeaveStatusNotification")) return "Your leave status changed";
  return "Notification";
};

const Notification = () => {
  const navigate = useNavigate();
  const { data, isLoading, isError, error } = useGetNotificationQuery();

  if (isLoading) return <SkeletonNotification rows={6} />;

  const raw = Array.isArray(data)
    ? data
    : Array.isArray(data?.data)
      ? data.data
      : [];

  const notifications = raw.map((n) => ({
    id: n.id,
    type: readableType(n.type ?? ""),
    message: n.data?.message || "",
    time: n.data?.time || "Earlier",
  }));

  return (
    <div>
      {/* Page header */}
      <div className="d-flex align-items-center justify-content-between mb-3 mt-2">
        <div className="d-flex align-items-center gap-2">
          <Icon
            name="arrow-left"
            style={{ fontSize: "18px", cursor: "pointer", fontWeight: 700 }}
            onClick={() => navigate(-1)}
          />
          <h4 className="fw-bold mb-0">Notification</h4>
        </div>
        <span
          style={{
            color: "var(--blue)",
            fontSize: "13px",
            fontWeight: 500,
            cursor: "pointer",
          }}
        >
          Mark as Read all
        </span>
      </div>

      {isError && (
        <div className="alert alert-danger">
          {error?.data?.message || "Failed to load notifications"}
        </div>
      )}

      <div className="bg-white rounded-3" style={{ padding: "4px 0" }}>
        {notifications.length === 0 && (
          <p className="p-4 text-muted text-center">No notifications</p>
        )}
        {notifications.map((n, i) => (
          <div
            key={n.id}
            className="d-flex align-items-start gap-3 px-4 py-3"
            style={{
              borderBottom:
                i < notifications.length - 1 ? "1px solid #f5f5f5" : "none",
            }}
          >
            {iconMap[n.type] && (
              <img
                src={iconMap[n.type]}
                alt={n.type}
                width={32}
                height={32}
                loading="lazy"
                style={{ flexShrink: 0 }}
              />
            )}
            <div className="flex-grow-1">
              <p className="fw-bold mb-1" style={{ fontSize: "14px" }}>
                {n.type}
              </p>
              <p className="text-muted mb-0" style={{ fontSize: "13px" }}>
                {n.message}
              </p>
            </div>
            <span
              style={{ fontSize: "12px", color: "#aaa", whiteSpace: "nowrap" }}
            >
              {n.time}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Notification;
